module.exports = __webpack_public_path__ + "images/37ee5266c74891596e40681d3c3eab21.svg";